import styled from '@emotion/styled'
import { Table as BootstrapTable } from 'react-bootstrap'
import Tr from './Tr'

type TableType = {
    tableHeader: string[]
    tableData: any[]
    deleteById?: (id: number) => void
    noDataMessage?: string
    'data-testid'?: string
}

const Table = ({ tableHeader, tableData, deleteById, noDataMessage, 'data-testid': dataTestId }: TableType) => {
    return (
        <BootstrapTable responsive data-testid={dataTestId}>
            <thead>
                <tr>
                    {tableHeader.map((headerItem, index) => (
                        <th key={`th${index}`}>{headerItem}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {tableData.length > 0 ? (
                    tableData.map((dataItem) => {
                        const id = Array.isArray(dataItem[0]) ? dataItem[0][1] : dataItem.id
                        return <Tr key={`tr${id}`} deleteById={deleteById} dataItem={dataItem} id={id} />
                    })
                ) : (
                    <tr>
                        <CenterTd colSpan={tableHeader.length}>{noDataMessage ?? 'Aucune donnée trouvée'} </CenterTd>
                    </tr>
                )}
            </tbody>
        </BootstrapTable>
    )
}

const CenterTd = styled.td`
    text-align: center;
`

export default Table
